import axios from 'axios';

export function isOktaActive() {
    return axios.get(`/okta-is-active`);
}
